/* nt-utils.js — small shared DOM/data helpers used by other nt-*.js files and section scripts. */
window.NT = window.NT || {};

(function (NT) {
  NT.qs = function (sel, root) {
    return (root || document).querySelector(sel);
  };
  NT.qsa = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };
  NT.on = function (el, type, handler, opts) {
    if (el) el.addEventListener(type, handler, opts);
  };
  NT.debounce = function (fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  };
  NT.reducedMotion = function () {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };
  NT.params = function () {
    return new URLSearchParams(window.location.search);
  };
  NT.escapeHtml = function (str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* session-scoped "seen it already" flags, used by the scroll nudge popup */
  NT.session = {
    get: function (key) {
      try { return sessionStorage.getItem(key); } catch (e) { return null; }
    },
    set: function (key, val) {
      try { sessionStorage.setItem(key, val); } catch (e) {}
    }
  };
})(window.NT);
